module.exports = __webpack_public_path__ + "media/npc_dota_hero_rattletrap.858e42c4.webm";